
import img1 from '../images/collection/collection1.jpg'
import img2 from '../images/collection/collection2.jpg'
import img3 from '../images/collection/collection3.jpg'
import img4 from '../images/collection/collection4.jpg'
import img5 from '../images/collection/collection5.jpg'
import img6 from '../images/collection/collection6.jpg'
import img8 from '../images/collection/collection8.jpg'
import img9 from '../images/collection/collection9.jpg'
import img10 from '../images/collection/collection10.jpg'
import img11 from '../images/collection/collection11.jpg'
import img12 from '../images/collection/collection12.jpg'
import img13 from '../images/collection/collection34.jpg'
import img14 from '../images/collection/collection35.jpg'
import img15 from '../images/collection/collection36.jpg'
import img16 from '../images/collection/collection37.jpg'
import img17 from '../images/collection/collection38.jpg'
import img18 from '../images/collection/collection39.jpg'
import img19 from '../images/collection/collection34.jpg'
import img20 from '../images/collection/collection35.jpg'
import img21 from '../images/collection/collection36.jpg'

import avt1 from '../images/author/author-cl.png'
import avt2 from '../images/author/author-cl2.jpg'

const dataCollection = [
    {
        id: 1,
        img1: img1,
        img2: img2,
        img3: img3,
        avt: avt1,
        name: 'Entertainments',
        count: '26 Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹350'
    },
    {
        id: 2,
        img1: img4,
        img2: img5,
        img3: img6,
        avt: avt1,
        name: 'Filpkart & Amazon Duo',
        count: '12Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹200'
    },
    {
        id: 3,
        img1: img1,
        img2: img8,
        img3: img9,
        avt: avt1,
        name: 'Shop & Gaming Fun',
        count: '82 Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹650'
    },
    {
        id: 4,
        img1: img10,
        img2: img11,
        img3: img12,
        avt: avt1,
        name: 'Enjoy Premium Apps',
        count: '40 Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹290'
    },


    {
        id: 5,
        img1: img13,
        img2: img14,
        img3: img15,
        avt: avt2,
        title: 'Gift Collection',
        name: '@TopBrands',
        count: '26 Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹500'
    },
    {
        id: 6,
        img1: img16,
        img2: img17,
        img3: img18,
        avt: avt2,
        title: 'Gaming Cards',
        name: '@TopBrands',
        count: '26 Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹500'
    },
    {
        id: 7,
        img1: img19,
        img2: img20,
        img3: img21,
        avt: avt2,
        title: 'Gift Collection',
        name: '@TopBrands',
        count: '26 Vouchers',
        price : '₹5000 Value',
        pricesale: 'Save ₹500'
    },



   
]

export default dataCollection;